export default __webpack_public_path__ + "static/media/step_2.ee149e45.svg";